import React from 'react';

import { faUserTag } from '@fortawesome/pro-regular-svg-icons';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { map } from 'lodash/fp';

import axios from '../modules/axios';
import GestionDPAssistant from '../pages/affectations-dp-dept/GestionDPAssistant';

export default {
  name: 'affectations-dp-dept',
  title: 'Affectations DP/Depts',
  resource: 'cmap_individu',
  primaryKey: 'cmap_dpt_id',
  icon: faUserTag,
  query: { _associations: '*departement,*individu' },
  sort: 'cmap_dpt_id',
  limit: 104,
  head: {
    cmap_dpt_id: 'Départements',
    individu_fullname: 'Délégué(e)s',
  },
  prerequisitesProps: async () => {
    const res = await axios.get(`individu_centrale?_associations=*individu&individu_centrale_isDp=1&individu.delete=0`);

    return {
      deleguesProgramme: map('individu', res.data),
    };
  },
  customActions: [<GestionDPAssistant key='gestion-dp-assistant' />],
  list: ({ values: row }) => [
    `${row.cmap_dpt_id} - ${row.departement?.titre_dpt || ''}`,
    `${row.individu?.nom} ${row.individu?.prenom}`,
  ],
  edit: ({ values, handleChange, preProps: { deleguesProgramme } }) => {
    return [
      <Grid container direction='column' spacing={2}>
        <Grid item xs={12}>
          {`${values.cmap_dpt_id} - ${values.departement?.titre_dpt || ''}`}
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth variant='outlined' size='small'>
            <InputLabel>{`${values.cmap_dpt_id} - ${values.departement?.titre_dpt || ''}`}</InputLabel>
            <Select
              label={`${values.cmap_dpt_id} - ${values.departement?.titre_dpt || ''}`}
              name='cmap_individu_id'
              value={values.cmap_individu_id}
              onChange={handleChange}
            >
              {deleguesProgramme.map(individu => (
                <MenuItem
                  key={individu.idindividu}
                  value={individu.idindividu}
                >{`${individu?.nom} ${individu?.prenom}`}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>,
    ];
  },
  popup: true,
};
